(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["appointo-modal"] && !Shopify.designMode) return;
  try {
    const btn = document.getElementById("openAppointo");
    const modal = document.getElementById("appointo-modal");
    const closeBtn = document.querySelector(".appointo-close-cur");
    document.addEventListener("DOMContentLoaded", function () {
        if (!btn || !modal) return;

        // 点击按钮显示
        btn.addEventListener("click", () => {
           openModal();
        });

        // 点击关闭按钮
        closeBtn?.addEventListener("click", () => {
        modal.style.display = "none";
        });

        // 点击背景关闭
        window.addEventListener("click", (e) => {
        if (e.target === modal) {
            modal.style.display = "none";
        }
        });
    });

    function openModal(){
      modal.style.display = "flex"; // flex 方便居中
      if(isMobile()){
        const modalContent = document.getElementById("appointo-modal-content");
        modalContent.classList.remove("appointo-modal-content-embed");
        setTimeout(() => {
          modalContent.classList.remove("appointo-modal-content-embed");
        }, 1000);
      }
    }
    // document.dispatchEvent(new CustomEvent("appointo:opened"));
    document.addEventListener("appointo:opened", (e) => {
      console.log("已打开", e.detail);
      openModal();
    });
  } catch(e) { console.error(e); }
})();

})();
